import React from 'react';
import gql from "graphql-tag";

export const LOGIN = gql`
    mutation login($email: Email!, $password: String!) {
        login (
            email: $email,
            password: $password
        )
        {
            jwt
        }
    }
`

